const prefix = 'published_lesson_admin';

export const PUBLISHED_LESSONS_ADMIN_PREFIX = prefix;

export const FETCHED_PUBLISHED_LESSONS = `${prefix}/fetched`;
export const LESSON_PUBLISHED          = `${prefix}/lessonPublished`;
export const PUBLISHED_LESSON_DELETED  = `${prefix}/publishedLessonDeleted`;

export const ERROR_PUBLISH_DATE_IN_PAST   = 'Publish.DateInPast';
export const ERROR_REPUBLISH_DATE_IN_PAST = 'Republish.DateInPast';

export const ERROR_IKNOW_SYNC_FAILED = 'Exception.IknowSyncService::SyncError';
